import { render, staticRenderFns } from "./TransferenciasPublicas.vue?vue&type=template&id=6eb0e63d&scoped=true"
import script from "./TransferenciasPublicas.vue?vue&type=script&lang=ts"
export * from "./TransferenciasPublicas.vue?vue&type=script&lang=ts"
import style0 from "./TransferenciasPublicas.vue?vue&type=style&index=0&id=6eb0e63d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb0e63d",
  null
  
)

export default component.exports